<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder

      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  watch: {
    search(val) {
      if (!val) {
        this.resetSearch();
        if (!this.select) {
          this.items = [];
        }
        return;
      }

      if (this.select && val === this.select.text) {
        return;
      }

      val !== this.select && this.querySelections(val) // eslint-disable-line
    }
  },

  beforeDestroy() {
    this.destroyed = true;
    this.resetSearch();
  },

  methods: {
    resetSearch() {
      if (this.searchTimeout != null) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.searchSeq = (this.searchSeq || 0) + 1;
      this.loading = false;
    },

    querySelections(value) {
      this.resetSearch();

      if (!this.geocoder) {
        return;
      }

      const seq = this.searchSeq;
      this.loading = true;

      this.searchTimeout = setTimeout(() => {
        this.searchTimeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (this.destroyed || seq !== this.searchSeq || items === null) {
            return;
          }

          this.items = items.slice();
          this.loading = false;
        });
      }, 150);
    },

    change(o) {
      this.resetSearch();
      this.$emit("change", o);
    }
  }
};
</script>
